import React, { useEffect, useRef, useState } from "react"

import { StyledGlobalIntegrationSection } from "./GlobalIntegrationSection.styles"
import { Container, Card, Row, Col } from "react-bootstrap"

import HouseIcon from "./HouseIcon"
import TopRight from "./TopRight"
import Logo from "../../Global/Layout/Logo/Logo"
import BubbleGumButton from "./BubbleGumButton"
import BigGreenCheckAnimated from "./AdaptiveBigGreenCheckAnimated"
import DownChevron from "./DownChevron"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import NewDivider from "./AdaptiveDivider"
import { motion } from "framer-motion"
import CurvedLine from "./AdaptiveCurvedLine"
import TransactionInProgress from "./TransactionInProgress"
import { useInView } from "react-intersection-observer"
import Switch from "./Switch"
import { CountriesData } from "../../../data/homePage.data"

import loadable from "@loadable/component"

const TextTransition = loadable(() => import("react-text-transition"))
const ReactCountryFlag = loadable(() => import("react-country-flag"))

const GlobalIntegrationSection = () => {
  const wrapperRef = useRef(null);
  const [scrollYProgress, setScrollYProgress] = useState(0);

  const [index, setIndex] = useState(0);
    useEffect(() => {
        const intervalId = setInterval(
        () => {
            setIndex((index) => index + 1)
        },
        3000 // every 3 seconds
        )
        return () => {
        clearInterval(intervalId)
        }
    }, [])

  const [ref, inView] = useInView({ rootMargin: "300px 0px -350px 0px" })
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: { relativeDirectory: { eq: "grouped_logos" } }
        sort: { fields: absolutePath, order: ASC }
      ) {
        edges {
          node {
            id
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const { amount, cityName, countryCode, img, alt } = CountriesData[
    index % CountriesData.length
  ]

  useEffect(() => {
    const handleScroll = () => {
      const element = wrapperRef.current;
      const elementPercentagePercentage = elementScrollPercentage(element);
      if (scrollYProgress !== elementPercentagePercentage) {
        setScrollYProgress(() => elementPercentagePercentage);
      }
    };
  
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      window.removeEventListener('scroll', handleScroll); // Cleanup event listener
    };
  }, [scrollYProgress]); // Add scrollYProgress to the dependency array

  function elementScrollPercentage(element){
    const elementHeight = element.offsetHeight;
    const elementTop = element.getBoundingClientRect().top - window.innerHeight + window.scrollY;
    const scrollTop = window.scrollY || window.pageYOffset;
    const elementScrollProgress = scrollTop - elementTop;
    let elementPercentageProgress = elementScrollProgress / elementHeight;

    if (elementPercentageProgress > 1.1) {
      elementPercentageProgress = 1.1;
    }else if (elementPercentageProgress < 0) {
      elementPercentageProgress = 0;
    }

    return elementPercentageProgress;
  }

  function elementScrollProgress(lowerBound, upperBound, target){
    let range = (target - lowerBound) / (upperBound - lowerBound);
    range = Math.max(0, Math.min(range, 1));
    return range;
  }

  function marginOffsetCalc(offset, scale) {
    return offset - (offset * scale);
  }


  const images = data.allFile.edges
  return (
    <StyledGlobalIntegrationSection className="pt-5 pb-5 poppins d-none d-lg-block" ref={wrapperRef}>
      <Container>
        <h2 className="h1 ambit font-weight-bold text-center mb-5 mt-5">Payment Orchestration Platform</h2>
        <div className="text-center">
          <DownChevron className="chevron mb-5" />
          <div className="d-flex align-items-center" style={{ position: 'relative', zIndex: '1' }}>
            <HouseIcon className="house-icon" />
          </div>
        </div>
        <div className="text-center mt-5">
          <p className="pt-2">Merchant</p>
        </div>

        <NewDivider
          height={650}
          range={[0.2, 0.67]}
          scrollYProgress={scrollYProgress}
        />

        <div
          className="d-flex justify-content-end top-right w-75"
          style={{ height: "150px" }}
        >
          <motion.div
            style={{
              scale: elementScrollProgress(0.25, 0.32, scrollYProgress),
            }}
          >
            <TopRight className="tr-image" />
            <TransactionInProgress liNumber={"01"} showDesc={true}/>
          </motion.div>
        </div>
        <motion.div
          className="text-center"
          style={{
            scale: elementScrollProgress(0.32, 0.4, scrollYProgress),
          }}
        >
          <Card className="mx-auto">
            <Card.Header className="p-4 d-flex justify-content-between">
              <span>
                <TextTransition text={amount} />
              </span>

              <img src={img} className="img-fluid" alt={alt} />
            </Card.Header>
            <Card.Footer className="d-flex justify-content-between p-4 align-items-center text-white">
              <span>Detected Location:</span>
              <span className="d-flex align-items-center">
                <TextTransition className="font-weight-bold" text={cityName} />
                &nbsp;
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg
                  className="rounded-circle ml-2"
                />
              </span>
            </Card.Footer>
          </Card>
        </motion.div>

        <motion.div
          className="d-flex top-right align-content-center p-5"
          style={{
            scale: elementScrollProgress(0.49, 0.56, scrollYProgress),
          }}
        >
          <TransactionInProgress liNumber={"02"} className="tip-2" title="Currency & location detected"/>
          <div className="pound d-flex align-items-center">
            <span className="rounded-circle text-center poppins">&pound;</span>
          </div>
        </motion.div>
        <div className="d-flex justify-content-center pt-5 pb-0 ">
          <div
            className="check-box d-flex justify-content-center rounded-circle align-content-center"
            ref={ref}
          >
            <Switch checked={inView} />
          </div>
        </div>

        <div className="d-flex justify-content-center transaction-3 align-items-center">
          <motion.div
            className="pr-2"
            style={{
              scale: elementScrollProgress(0.70, 0.75, scrollYProgress),
              marginBottom: "28px",
            }}
          >
            <Logo />
            <h4>Orchestration Platform</h4>
          </motion.div>

          <NewDivider
            height={150}
            range={[0.7, 0.75]}
            scrollYProgress={scrollYProgress}
          />
          <motion.div
            className="pl-5"
            style={{
              scale: elementScrollProgress(0.70, 0.75, scrollYProgress),
            }}
          >
            <TransactionInProgress liNumber={"03"} title="Routing to optimal acquirer"/>
          </motion.div>
        </div>

        <Row style={{ minHeight: "400px" }}>
          <Col className="d-flex flex-column mt-5">
            <CurvedLine
              className="curved-line-1 mt-1"
              scrollYProgress={elementScrollProgress(0.75, 0.85, scrollYProgress)}
            />
            <motion.div
              className="bubble-gum-brand text-center w-50 mx-auto"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton text="United States" />
              <Img
                alt="JP Morgan, First Data, PayPal"
                className="w-75 mx-auto"
                fluid={images[0].node.childImageSharp.fluid}
              />
            </motion.div>
            <motion.div
              className="bubble-gum-brand text-center w-50 mx-auto"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton
                fill="rgba(56, 93, 167, 0.6)"
                text="Latin America"
              />
              <Img
              alt="7Eleven, Cielo, Oxxo, Banamex"
                className="w-75 mx-auto"
                fluid={images[1].node.childImageSharp.fluid}
              />
            </motion.div>
          </Col>

          <NewDivider
            height={490}
            range={[0.90, 1]}
            style={{ marginTop: "-42px" }}
            scrollYProgress={scrollYProgress}
          />

          <Col className="d-flex flex-column align-items-center mt-5">
            <motion.div
              className="bubble-gum-brand text-center w-50"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton fill="rgba(30, 127, 194, 0.6)" text="Europe" />
              <Img alt="Barclaycard, Elavon" fluid={images[2].node.childImageSharp.fluid} />
            </motion.div>

            <motion.div
              className="bubble-gum-brand text-center w-50"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton text="Middle East" />
              <Img alt="Mashreq"
                className="w-75 mx-auto"
                fluid={images[3].node.childImageSharp.fluid}
              />
            </motion.div>
          </Col>

          <Col className="d-flex flex-column align-items-center mt-5">
            <motion.div
              className="bubble-gum-brand text-center w-50"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton fill="rgba(56, 93, 167, 0.6)" text="India" />
              <Img alt="ICICI Bank, PayTM, RuPay"
                className="mx-auto"
                fluid={images[4].node.childImageSharp.fluid}
              />
            </motion.div>

            <motion.div
              className="bubble-gum-brand text-center w-50 mt-5"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton fill="rgba(30, 127, 194, 0.6)" text="China" />
              <Img alt="Payeco, WeChat Pay, Alipay, UnionPay"
                className="mx-auto"
                fluid={images[5].node.childImageSharp.fluid}
              />
            </motion.div>
          </Col>
          <Col className="d-flex flex-column align-items-center mt-5">
            <CurvedLine
              className="curved-line-2"
              scrollYProgress={elementScrollProgress(0.75, 0.85, scrollYProgress)}
            />

            <motion.div
              className="bubble-gum-brand text-center w-50"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton
                text="Africa"
              />
              <Img alt="United Bank of Africa, Standard Bank of South Africa, ABSA Africa-Ghana, Ecobank"
                className=" mx-auto"
                fluid={images[6].node.childImageSharp.fluid}
              />
            </motion.div>

            <motion.div
              className="bubble-gum-brand text-center w-50"
              style={{
                scale: elementScrollProgress(0.85, 0.90, scrollYProgress),
              }}
            >
              <BubbleGumButton
                fill="rgba(56, 93, 167, 0.6)"
                text="Australia"
              />
              <Img alt="First Data, After Pay, Poli"
                className="w-75 mx-auto"
                fluid={images[7].node.childImageSharp.fluid}
              />
            </motion.div>
          </Col>
        </Row>

        <div className="text-center mt-3" style={{position: "relative",zIndex: "1"}}>
          <BigGreenCheckAnimated
            className="green-check"
            opacity={elementScrollProgress(1, 1.04, scrollYProgress)}
            rotate={elementScrollProgress(1, 1.04, scrollYProgress)}
          />
          <motion.h5
            className="mt-4 mb-5"
            style={{
              opacity: elementScrollProgress(1, 1.04, scrollYProgress),
              y: marginOffsetCalc(-30, elementScrollProgress(1, 1.04, scrollYProgress)),
              transition: {
                ease: "linear",
              },
            }}
          >
            Payment Accepted
          </motion.h5>
        </div>
      </Container>
    </StyledGlobalIntegrationSection>
  )
}

export default GlobalIntegrationSection
